import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
} from "reactstrap";
import NotificationImage from "../Notifications/NotificationImage";
import NotificationVideo from "../Notifications/NotificationVideo";
import { FormattedMessage } from "react-intl";

export default function NotificationModal({
  isOpen,
  toggle,
  notification,
  handleMarkAsRead,
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      scrollable
      style={{ maxWidth: "900px", width: "100%" }}
    >
      <ModalHeader toggle={toggle}>{notification.notice.title}</ModalHeader>
      <ModalBody className="mx-auto" style={{ overflowX: "hidden" }}>
        <Row>
          <span
            className="mx-4"
            dangerouslySetInnerHTML={{ __html: notification.notice.text }}
          />
        </Row>
        <Row
          className="mt-2 mx-auto"
          style={{ width: "853px", maxHeight: "480px" }}
        >
          {notification.notice.image && (
            <NotificationImage noticeId={notification.notice.id} />
          )}
          {notification.notice.video &&
            notification.notice.video !== "null" && (
              <NotificationVideo videoUrl={notification.notice.video} />
            )}
        </Row>
      </ModalBody>
      <ModalFooter>
        <div className="d-flex">
          <Button
            onClick={toggle}
            className="pull-right mx-1"
            color="secondary"
            outline
          >
            <FormattedMessage id="Cancel" />
          </Button>
          {!notification.isSeenByMe && (
            <Button
              onClick={() => handleMarkAsRead(notification.notice.id, true)}
              className="pull-right mx-1"
              color="primary"
              outline
            >
              <FormattedMessage id="MarkAsRead" />
            </Button>
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
}
